<template>
    <rkm-form ref="RkmForm">
        <rkm-area
            no-margin-top
            title="De"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :resultsLimit="20"
                        :repository="repositories.unificacaoUsuarioPaciente"
                        :search-fields="fields"
                        :text-field="item => `${item.nome}${item.cns ? ' - ' + item.cns : ''}${item.prontuario ? ' - ' + item.prontuario : ''}`"
                        :validations="validations.cidadaoDe"
                        label="Usuário/Paciente"
                        v-model="model.cidadaoDe"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :value="model.cidadaoDe && model.cidadaoDe.tipoCidadao"
                        disabled
                        label="Tipo"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-date-picker
                        :value="model.cidadaoDe && model.cidadaoDe.dataNascimento"
                        disabled
                        label="Data de nascimento"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :value="model.cidadaoDe && model.cidadaoDe.nomeMae"
                        disabled
                        label="Nome da mãe"
                    />
                </rkm-col>

                <rkm-col colas="3">
                    <rkm-form-input
                        :value="model.cidadaoDe && model.cidadaoDe.cns"
                        disabled
                        label="CNS"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :value="model.cidadaoDe && model.cidadaoDe.cpf"
                        disabled
                        label="CPF"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Para"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :disabled="!model.cidadaoDe"
                        :excludeValue="{prop: ['id'], value: {id: model.cidadaoDe && model.cidadaoDe.id}}"
                        :repository="repositories.unificacaoUsuarioPaciente"
                        :search-fields="fields"
                        :text-field="item => `${item.nome}${item.cns ? ' - ' + item.cns : ''}${item.prontuario ? ' - ' + item.prontuario : ''}`"
                        :validations="validations.cidadaoPara"
                        label="Usuário/Paciente"
                        v-model="model.cidadaoPara"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :value="model.cidadaoPara && model.cidadaoPara.tipoCidadao"
                        disabled
                        label="Tipo"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-date-picker
                        :value="model.cidadaoPara && model.cidadaoPara.dataNascimento"
                        disabled
                        label="Data de nascimento"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :value="model.cidadaoPara && model.cidadaoPara.nomeMae"
                        disabled
                        label="Nome da mãe"
                    />
                </rkm-col>

                <rkm-col colas="3">
                    <rkm-form-input
                        :value="model.cidadaoPara && model.cidadaoPara.cns"
                        disabled
                        label="CNS"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :value="model.cidadaoPara && model.cidadaoPara.cpf"
                        disabled
                        label="CPF"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                cidadaoDe: {required: true},
                cidadaoPara: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            unificacaoUsuarioPaciente: this.getConectaSusRepository('cadastro.unificacaoUsuarioPaciente'),
        }
    },
    data: () => ({
        fields: [
            {key: 'cadastro_cidadao.nome', searchable: true},
            {key: 'cadastro_cidadao.cns', searchable: true},
            {key: 'cadastro_cidadao.cpf', searchable: true},
            {key: 'cadastro_paciente.prontuario', searchable: true},
            {key: 'cadastro_cidadao.data_nascimento', searchable: true}
        ],
        model: {
            cidadaoDe: null,
            cidadaoPara: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleStore() {
            this.showWarningConfirmation(
                'Atenção',
                'Deseja realmente unificar os usuários e/ou pacientes?',
                async () => {
                    this.$nextTick().then(() => this.showWarningConfirmation(
                        'Atenção',
                        'Esta ação não poderá ser desfeita, deseja mesmo continuar?',
                        async () => this.store()
                    ))
                }
            )
        },
        store() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (!valid) return

                    this.setLoading()

                    this.repositories.unificacaoUsuarioPaciente.store(this.camelObjectKeysToSnakeRecursive(this.model))
                        .then(() => {
                            this.reset()
                            this.showSaveNotification()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        reset() {
            this.model = {
                cidadaoDe: null,
                cidadaoPara: null,
            }

            this.$refs.RkmForm.resetValidator()
        },
    },
    mixins: [error, repository, stringCase],
    watch: {
        'model.cidadaoDe'() {
            this.model.cidadaoPara = null
        },
    },
}
</script>

<style scoped>
.table-newlines {
    white-space: pre-line;
}
</style>